import Helper from '@lovata/popup-helper';

export default new class MobileNav {
  constructor() {
    this.mobileNavPanel = 'mobile-nav__panel';

    this.drawerSearchPanelSelector = 'js-search-popup-mobile';
    this.panelOpenSelector = 'search-panel_hidden';
    this.drawerBtnSearchSelector = 'search-panel';
    this.searchInputSelector = 'search-panel__input-field';

    this.sWishListInfoWrapper = 'mobile-nav__item_wishlist';

    this.sCartInfoWrapper = '_shopaholic-cart-mini-mobile-wrapper';

    this.mediaQueryList = window.matchMedia('(max-width: 769px)');

    document.addEventListener('DOMContentLoaded', () => {
      this.load();
    });
  }

  load() {
    if (!this.mediaQueryList.matches) return;

    const mobileNavPanel = document.querySelector(`.${this.mobileNavPanel}`);
    if (mobileNavPanel) return;

    const div = document.createElement('div');
    const body = document.querySelector('body');
    div.classList.add(this.mobileNavPanel);
    body.append(div);

    $.request('onAjax', {
      update: {
        'footer/mobile-nav/mobile-nav': `.${this.mobileNavPanel}`,
      },
      complete: () => {
        setTimeout(() => {
          this.openSearchMobile();
          this.updateWishListInfo();
          this.updateCartInfo();
        }, 200);
      },
    });
  }

  openSearchMobile() {
    const modal = document.querySelector(`.${this.drawerBtnSearchSelector}`);
    $(document)
      .on('click', `.${this.drawerSearchPanelSelector}`, (e) => {
        this.togglePopup(e, modal);
      });
  }

  togglePopup(eventObject, popup) {
    const searchInput = document.querySelector(`.${this.searchInputSelector}`);

    if (!searchInput) return;

    const { currentTarget } = eventObject;

    const panel = $('.search-panel');
    const isOpen = !panel.hasClass(this.panelOpenSelector);

    Helper.setBodyScrollState(isOpen);
    Helper.overlayHandler(!isOpen, currentTarget, popup);
    panel.toggleClass(this.panelOpenSelector);

    searchInput.focus();
  }

  updateWishListInfo() {
    $.request('ProductList::onAjaxRequest', {
      update: { 'product/wishlist/wishlist-info/wishlist-info': `.${this.sWishListInfoWrapper}` },
    });
  }

  updateCartInfo() {
    $.request('onAjax', {
      update: { 'product/cart/cart-mini/cart-info/cart-info': `.${this.sCartInfoWrapper}` },
    });
  }
}();
